import { action } from 'easy-peasy';
import { IActionSetMoreStatusPatients } from '../types';
import { mergeUniqueBy } from '~/utils/pagination';

const setMoreStatusPatients: IActionSetMoreStatusPatients = action((state, payload) => {
  const hasMore = state.pagination.itemsPerPage === payload.patients.length;

  const newItems = mergeUniqueBy(state.statusPatients.patients, payload.patients, item => item.id);

  state.statusPatients.patients = [...newItems];

  state.statusPatients.total = payload.total;
  state.pagination.page += 1;
  state.pagination.hasMore = hasMore;
});

export default setMoreStatusPatients;
